import React, { useEffect } from 'react';
import './about.css';
import CustomButton from '../../components/Custom/CustomButton';
import AOS from 'aos'

const About = () => {

	useEffect(() => {
		AOS.init({ duration: 1000 });
	}, []);

	return (
		<div className='abt' id='about'>
			<img src='/ravi.jpg' alt='profile' className="pic" data-aos='fade-up' data-aos-offset='240' />
			<div className="abt_cont">
				<h2 className="abt_title text-neon" data-aos='fade-up' data-aos-offset='220'>About Me</h2>
				<h2 className="res_abt_title text-neon" data-aos='fade-up' data-aos-offset='320'>About Me</h2>
				<div className="res_holder">
					<img src='/ravi.jpg' alt='profile' className="res_pic" data-aos='fade-up' data-aos-offset='350' />
					<div className="res_abt_btn_cont" data-aos='fade-up' data-aos-offset='300'>
						<CustomButton theme={"#00fffc"} text={"View Resume"} onHandle={() => window.open('https://drive.google.com/file/d/1FdpPl62IX3uxH37viDApIO8hQdMTpods/view', '_blank', 'noreferrer')} />
						<CustomButton theme={"#00fffc"} text={"Hire Me"} onHandle={() => window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&to=ravivarma25052@gmail.com', '_blank', 'noreferrer')} />
					</div>
				</div>
				<div className='abt_content'>
					<p data-aos='fade-up' data-aos-offset='180'>
						You've arrived at my portfolio, and you've already seen my name above. But just in case you missed it, I'm <span className="text-neon font-semibold tracking-wider">Ravi Kiran</span> !, a <span className='tracking-wider font-semibold'>CODESMITH</span> who forges creative solutions, builds cool stuff, and break things (only to fix them better), and always curious about turning ideas into reality. Whether it's designing sleek UIs, optimizing performance, or just making things work (somehow). My journey is an ever-evolving story of Creation, problem-solving, and crafting digital experiences that leave a mark.
					</p>
				</div>
				<div className="abt_btn_cont" data-aos='fade-up' data-aos-offset='50'>
					<CustomButton theme={"#00fffc"} text={"View Resume"} onHandle={() => window.open('https://drive.google.com/file/d/1FdpPl62IX3uxH37viDApIO8hQdMTpods/view', '_blank', 'noreferrer')} />
					<CustomButton theme={"#00fffc"} text={"Hire Me"} onHandle={() => window.open('https://mail.google.com/mail/u/0/?view=cm&fs=1&to=ravivarma25052@gmail.com', '_blank', 'noreferrer')} />
				</div>
			</div>
		</div>
	)
}

export default About